import { WidgetGallery } from '../../../../common/types/api/page'

export const removeInvalidWidgets = (widgetGallery: WidgetGallery[][]): WidgetGallery[][] => {
    return [...widgetGallery].map(gallery => {
        return gallery.filter(mappedWidget => mappedWidget.widgetId !== 0)
    })
}
